import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { DeleteIcon } from 'src/components/SkladonIcon/SmallIcons';
import { ProviderTransferCompanyType } from 'src/types/providerTransferCompany';

export interface TopBlockPropsType {
    data: ProviderTransferCompanyType | null;
    idProviderTransferCompany: string | undefined;
    newProviderTransferCompany: boolean;
    disableEdit: boolean;
    disableDelete: boolean;
    handleSave: () => void;
    handleDeleteProviderTransferCompany: () => void;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    return (
        <>
            <BodyTopBlock
                actions={[
                    {
                        icon: <DeleteIcon />,
                        onClick: () => {
                            props.handleDeleteProviderTransferCompany();
                        },
                        tooltip: translate('providerTransferCompanyDetail.deleteProviderTransferCompany'),
                        hidden: props.disableDelete,
                        variant: 'outlined',
                    },
                    {
                        label: translate(
                            props.newProviderTransferCompany ? 'providerTransferCompanyDetail.create' : 'providerTransferCompanyDetail.save'
                        ),
                        onClick: () => {
                            props.handleSave();
                        },
                        hidden: props.disableEdit,
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
